<template>
    <div>
        <div class="row">
            <div class="col-md-6">

                <div class="row margin-top-20">
                    <div class="col-md-12">
                        <h5><strong>Thông tin</strong></h5>
                    </div>

                </div>
                <div class="row margin-top-20">
                    <div class="col-md-4">
                        Bộ sách
                    </div>
                    <div class="col-md-8">
                        <b-form-select disabled="disabled" v-model="form.bookTypeId" :options="listBookType" class="">
                            <option value="">Chọn bộ sách</option>
                        </b-form-select>
                    </div>
                </div>
                <div class="row margin-top-20">
                    <div class="col-md-4">
                        Khối lớp
                    </div>
                    <div class="col-md-8">
                        <b-form-select disabled v-model="form.classId" :options="listDataClass" class="">
                            <option value="">Chọn lớp học</option>
                        </b-form-select>
                    </div>
                </div>
                <div class="row margin-top-20">
                    <div class="col-md-4">
                        Môn học
                    </div>
                    <div class="col-md-8">
                        <b-form-select disabled v-model="form.subjectId" :options="listDataSubject" class="">
                            <option value="">Chọn môn học</option>
                        </b-form-select>
                    </div>
                </div>
                <div class="row margin-top-20">
                    <div class="col-md-4">
                        Số tiết
                    </div>
                    <div class="col-md-8">
                        <span>
                            {{ form.numberLesson }}
                        </span>
                    </div>
                </div>
                <div class="row margin-top-20">
                    <div class="col-md-12">
                        {{ form.description }}
                    </div>
                </div>
            </div>
            <div class="col-md-6 comment-electrolic-lecture margin-top-20">
                <CommentLessonPlaning />
            </div>
        </div>

    </div>
</template>
<script>
import CommentLessonPlaning from './_components/CommentLessonPlaning'
import { getAllTypeFilter, getAllClassFilter } from './../../_api/'
export default {
    components: {
        CommentLessonPlaning
    },
    props: {
        dataLessonPlaning: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }
    },
    data() {
        return {
            isEditDescription: false,
            isEditNumberLesson: false,
            listDataSubject: [],
            listDataClass: [],
            listBookType: [],
            form: {
                id: this.dataLessonPlaning.id,
                name: this.dataLessonPlaning.name,
                bookTypeId: this.dataLessonPlaning.bookTypeId,
                classId: this.dataLessonPlaning.classId,
                subjectId: this.dataLessonPlaning.subjectId,
                numberLesson: this.dataLessonPlaning.numberLesson,
                description: this.dataLessonPlaning.description,
                isPublic: this.dataLessonPlaning.isPublic,
                type: this.dataLessonPlaning.type,
            }
        }
    },
    mounted() {

        this.getTypesFilter()
        this.GetAllClass()
    },
    methods: {
        handleEditDescription() {
            this.isEditDescription = true
        },
        handleCancelEditDescription() {
            this.isEditDescription = false
        },
        getDetailLessonClassSchool() {
            this.$emit('getDetailLessonClassSchool')
        },
        handleCancelEditNumberLesson() {
            this.isEditNumberLesson = false
        },
        handleEditNumberLesson() {
            this.isEditNumberLesson = true
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = []
            self.listBookType = []
            getAllTypeFilter({}).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                    for (let i = 0; i < res.data.ltsBookType.length; i++) {
                        const item = res.data.ltsBookType[i];
                        self.listBookType.push({ value: item.bookGroupId, text: item.name })
                    }
                }
            })
        },
        GetAllClass() {
            let self = this
            self.listDataClass = []
            getAllClassFilter({}).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name })
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.icon-edit {
    width: 15px;
    cursor: pointer;
}

.btn-agree {
    margin-left: 10px;
    background: #0f3dba;
    color: white;
    line-height: 19px;
}

.margin-top-20 {
    margin-top: 20px;
}
</style>